<template>
  <div class="receipt-88">
      <div style="width: 88mm;" v-html="receiptHtml">

    </div>
  </div>
</template>
<style type="text/css">

 .receipt-88 h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6, div{
      color: #000;
  }
</style>
<script>
const API_URL = process.env.VUE_APP_API;

export default {
  name: "receipt",
  data(){
    return {
        receiptHtml:""
    };
  },
  mounted() {
    this.getReceipt();
  }, 
  methods: {
    getReceipt(){
    this.$http
      .get(API_URL + "/order/"+this.$route.params.receiptId+"/receipt", {
        headers: {
          Token: localStorage.getItem("access_token")
        }
      })
      .then(res => {
        this.receiptHtml = res.data.data
      });
    },
  }
};
</script>
<style>
</style>